import React, { useEffect } from 'react';
import QuoteDetailTabsListing from "../QuoteDetail/QuoteDetailTabsListing";
import useReduxState from "../../hooks/useReduxState";
import { CustomerInformation } from "../QuoteDetail/Component/CustomerInformation";
import keylegendIcon from 'src/assets/images/key.svg'
import opencreateIcon from 'src/assets/images/open_create.svg'
import { Tooltip } from 'src/component/Global/Tooltip';
import System from 'src/helper/system';
import Quote from "@system/config/quote";
import { useQuoteStore } from 'src/hooks/quote';

export default function QuoteDetail(props) {
    const [selectedTab] = useReduxState('', 'searchParams')
    const [{ submittedQuoteList }, { }, { destroy_cart_quote_active_session }] = useQuoteStore();
    const c = System.getParams();
    // const quoteNumber = submittedQuoteList?.records && submittedQuoteList?.records[0]?.quoteNumber + '-' + submittedQuoteList?.records[0]?.quoteRevisionNumber
    const displayQuoteNumber = submittedQuoteList?.records && submittedQuoteList?.records[0]?.displayQuoteNumber + '-' + submittedQuoteList?.records[0]?.quoteRevisionNumber


    const renderKeyLegendTooltip = () => {
        return (
            <>
                Offline: Quotes created in <br /> Avnet's Internal Quote Tool, online: Quotes created in Avnet.com
            </>
        )
    }

    useEffect(() => {
        destroy_cart_quote_active_session();
    }, []);

    return (

        <>
            <div className="container">
                <div
                    className="pcn-page-head header-container d-flex align-items-center justify-content-between">
                    <div className="page-title font-oswald font-light font-30">
                        Quote# {displayQuoteNumber}
                    </div>
                    <div className="ms-auto">
                        <ul className="list-inline mb-0">
                            <li>
                                <Tooltip
                                    position={'bottom center'}
                                    opener={() => (
                                        <a className="customer-link" href={void (0)}>
                                            <i> <img className="" src={keylegendIcon} alt='Key/Legend' /></i>
                                            <span className="bs5 text-blue">Key/Legend</span>
                                        </a>
                                    )}
                                    content={() => (
                                        renderKeyLegendTooltip()
                                    )}
                                />
                            </li>
                            {/* <li>
                                <Tooltip
                                    position={'bottom left'}
                                    opener={() => (
                                        <a className="customer-link" href={void (0)}><i><img src={infoIcon} alt='Information' /></i><span
                                            className="bs5 text-blue">Information</span></a>
                                    )}
                                    content={() => (
                                        renderInformationTooltip()
                                    )}
                                />
                            </li> */}
                            <li><a className="customer-link" href={Quote.getQuoteRouteURL()}>
                                <i><img src={opencreateIcon} alt='Open/Create Quote' /></i>
                                <span className="bs5 text-blue">Open/Create Quote</span>
                            </a></li>
                        </ul>
                    </div>
                </div>
                <CustomerInformation />
            </div>
            <div id="submitted-pcnquote-page" className="pcn-page container mt-3">
                <div className="customer-info quote-breakdown">
                    <div className="logged-screen">
                        <QuoteDetailTabsListing selectedTab={selectedTab} {...props} />
                    </div>
                </div>
            </div>
        </>

    );
}